import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="xv-seccion" aria-label={seccion.titulo}>
      <div className="xv-seccion-interior">
        <EncabezadoSeccion p="xv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="xv-titulo-itinerario" />
        <Reveal>
          <ul className="xv-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="xv-itinerario-item" key={i} data-testid={`xv-itinerario-item-${i}`}>
                  <span className="xv-itinerario-numero">{String(i + 1).padStart(2, "0")}</span>
                  <div className="xv-itinerario-cuerpo">
                    <p className="xv-itinerario-hora">
                      <Icono size={14} strokeWidth={1.5} />
                      {item.hora}
                    </p>
                    <h3 className="xv-itinerario-titulo">{item.titulo}</h3>
                    {item.descripcion && <p className="xv-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
